/**
 * @generated SignedSource<<544118d6ec24cf223c50f6d4e6ed6942>>
 * @relayHash eca0a30bf66912e40bcf380737e80884
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 70fcb97b8d5b72ad8c5f32ae12ecd53cb532ddd2c3aa3a519541d82f83df46f5

import type { ConcreteRequest } from 'relay-runtime';
export type CcpEntitlementPreDunningStatus = "IN_PRE_DUNNING" | "NOT_IN_PRE_DUNNING" | "%future added value";
export type GrowthUnifiedProfileTrialTrigger = "AUTO_UPGRADE_MEDIA_STORAGE_LIMIT" | "AUTO_UPGRADE_STORAGE_LIMIT" | "AUTO_UPGRADE_USER_LIMIT" | "CROSSFLOW_REVERSE_TRIAL" | "CROSSFLOW_USER_LIMIT" | "EDITION_PARITY" | "EDITION_PARITY_AUTO_PROVISIONING" | "REACTIVATION" | "REVERSE_TRIAL" | "UI" | "%future added value";
export type GrowthUnifiedProfileTrialType = "AUTO_UPGRADE" | "DIRECT_TRIAL" | "MANUAL_TRIAL" | "REVERSE_TRIAL" | "%future added value";
export type JiraApplicationKey = "JIRA_CORE" | "JIRA_CUSTOMER_SERVICE" | "JIRA_PRODUCT_DISCOVERY" | "JIRA_SERVICE_DESK" | "JIRA_SOFTWARE" | "%future added value";
export type CommerceEntitlementFilter = {
  AND?: ReadonlyArray<CommerceEntitlementFilter | null> | null;
  OR?: ReadonlyArray<CommerceEntitlementFilter | null> | null;
  hasRelationshipFromWithType?: string | null;
  inPreDunning?: boolean | null;
  inTrialOrPreDunning?: boolean | null;
};
export type editionAwarenessQuery$variables = {
  applicationKey: JiraApplicationKey;
  chargeElement: string;
  cloudId: string;
  entitlementFilter?: CommerceEntitlementFilter | null;
  isServiceCollectionFree?: boolean | null;
  productKey: string;
  shouldCheckForAddPaymentDetails: boolean;
  shouldCheckForChargeQuantities: boolean;
  shouldCheckForDirectBuyChangeOffering: boolean;
  shouldCheckForPaymentDetails: boolean;
  shouldCheckForStorageLimit: boolean;
  shouldCheckForStorageUsageJira: boolean;
  shouldCheckForTrial: boolean;
  shouldUseFilteredEntitlementRelationships?: boolean | null;
};
export type editionAwarenessQuery$data = {
  readonly csm_storage?: {
    readonly attachmentStorageAllowed: AGG$Long | null;
    readonly attachmentStorageIsUnlimited: boolean | null;
    readonly attachmentStorageUsed: AGG$Long | null;
  } | null;
  readonly jira?: {
    readonly attachmentStorageAllowed?: AGG$Long | null;
    readonly attachmentStorageIsUnlimited?: boolean | null;
    readonly attachmentStorageUsed: AGG$Long | null;
  } | null;
  readonly jsm_storage?: {
    readonly attachmentStorageAllowed: AGG$Long | null;
    readonly attachmentStorageIsUnlimited: boolean | null;
    readonly attachmentStorageUsed: AGG$Long | null;
  } | null;
  readonly tenantContexts: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement?: {
        readonly entitlementProfile: {
          readonly lastKnownTrial: {
            readonly createdAt: number | null;
            readonly offeringId: string | null;
            readonly trialEndTimeStamp: number | null;
            readonly trialTrigger: GrowthUnifiedProfileTrialTrigger | null;
            readonly trialType: GrowthUnifiedProfileTrialType | null;
          } | null;
        } | null;
        readonly experienceCapabilities: {
          readonly changeOfferingV2: {
            readonly experienceUrl: string | null;
            readonly isAvailableToUser: boolean | null;
          } | null;
          readonly changeOfferingV2WithSkipTrial?: {
            readonly experienceUrl: string | null;
            readonly isAvailableToUser: boolean | null;
          } | null;
        } | null;
        readonly latestUsageForChargeElement?: number | null;
        readonly offering?: {
          readonly key: string | null;
          readonly trial: {
            readonly lengthDays: number | null;
          } | null;
        } | null;
        readonly preDunning?: {
          readonly status: CcpEntitlementPreDunningStatus | null;
        } | null;
        readonly relatesFromEntitlements?: ReadonlyArray<{
          readonly entitlementId: string | null;
          readonly relationshipType: string | null;
        } | null> | null;
        readonly relatesFromEntitlementsWithCollectionType: ReadonlyArray<{
          readonly entitlement: {
            readonly entitlementProfile: {
              readonly lastKnownTrial: {
                readonly createdAt: number | null;
                readonly offeringId: string | null;
                readonly trialEndTimeStamp: number | null;
                readonly trialTrigger: GrowthUnifiedProfileTrialTrigger | null;
                readonly trialType: GrowthUnifiedProfileTrialType | null;
              } | null;
            } | null;
            readonly preDunning: {
              readonly status: CcpEntitlementPreDunningStatus | null;
            } | null;
          } | null;
          readonly entitlementId: string | null;
          readonly relationshipType: string | null;
        } | null> | null;
        readonly relatesFromEntitlementsWithEnterpriseType?: ReadonlyArray<{
          readonly entitlementId: string | null;
          readonly relationshipType: string | null;
        } | null> | null;
        readonly subscription?: {
          readonly accountDetails: {
            readonly invoiceGroup: {
              readonly experienceCapabilities: {
                readonly configurePaymentV2: {
                  readonly experienceUrl: string | null;
                  readonly isAvailableToUser: boolean | null;
                } | null;
              } | null;
              readonly invoiceable: boolean | null;
            } | null;
          } | null;
          readonly trial: {
            readonly endTimestamp: number | null;
            readonly startTimestamp: number | null;
            readonly timeLeft: number | null;
          } | null;
        } | null;
        readonly transactionAccount: {
          readonly experienceCapabilities?: {
            readonly addPaymentMethodV2: {
              readonly experienceUrl: string | null;
              readonly isAvailableToUser: boolean | null;
            } | null;
          } | null;
          readonly isBillToPresent?: boolean | null;
          readonly isCurrentUserBillingAdmin: boolean | null;
          readonly key: string | null;
        } | null;
      } | null;
      readonly entitlementId: string;
    } | null;
  } | null> | null;
};
export type editionAwarenessQuery = {
  response: editionAwarenessQuery$data;
  variables: editionAwarenessQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "applicationKey"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "chargeElement"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entitlementFilter"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isServiceCollectionFree"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productKey"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForAddPaymentDetails"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForChargeQuantities"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForDirectBuyChangeOffering"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForPaymentDetails"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForStorageLimit"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForStorageUsageJira"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForTrial"
},
v13 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "shouldUseFilteredEntitlementRelationships"
},
v14 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v15 = [
  {
    "kind": "Variable",
    "name": "applicationKey",
    "variableName": "applicationKey"
  },
  (v14/*: any*/)
],
v16 = {
  "condition": "shouldCheckForStorageUsageJira",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "condition": "shouldCheckForStorageLimit",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": (v15/*: any*/),
              "kind": "ScalarField",
              "name": "attachmentStorageAllowed"
            },
            {
              "args": (v15/*: any*/),
              "kind": "ScalarField",
              "name": "attachmentStorageIsUnlimited"
            }
          ]
        },
        {
          "args": (v15/*: any*/),
          "kind": "ScalarField",
          "name": "attachmentStorageUsed"
        }
      ]
    }
  ]
},
v17 = [
  {
    "kind": "Literal",
    "name": "applicationKey",
    "value": "JIRA_SERVICE_DESK"
  },
  (v14/*: any*/)
],
v18 = [
  {
    "kind": "Literal",
    "name": "applicationKey",
    "value": "JIRA_CUSTOMER_SERVICE"
  },
  (v14/*: any*/)
],
v19 = {
  "condition": "isServiceCollectionFree",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "jsm_storage",
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "args": (v17/*: any*/),
          "kind": "ScalarField",
          "name": "attachmentStorageAllowed"
        },
        {
          "args": (v17/*: any*/),
          "kind": "ScalarField",
          "name": "attachmentStorageUsed"
        },
        {
          "args": (v17/*: any*/),
          "kind": "ScalarField",
          "name": "attachmentStorageIsUnlimited"
        }
      ]
    },
    {
      "alias": "csm_storage",
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "args": (v18/*: any*/),
          "kind": "ScalarField",
          "name": "attachmentStorageAllowed"
        },
        {
          "args": (v18/*: any*/),
          "kind": "ScalarField",
          "name": "attachmentStorageUsed"
        },
        {
          "args": (v18/*: any*/),
          "kind": "ScalarField",
          "name": "attachmentStorageIsUnlimited"
        }
      ]
    }
  ]
},
v20 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v21 = [
  {
    "kind": "Variable",
    "name": "hamsProductKey",
    "variableName": "productKey"
  }
],
v22 = {
  "kind": "ScalarField",
  "name": "entitlementId"
},
v23 = [
  {
    "kind": "Variable",
    "name": "where",
    "variableName": "entitlementFilter"
  }
],
v24 = {
  "kind": "Literal",
  "name": "offeringName",
  "value": "Standard"
},
v25 = {
  "kind": "ScalarField",
  "name": "isAvailableToUser"
},
v26 = {
  "kind": "ScalarField",
  "name": "experienceUrl"
},
v27 = [
  (v25/*: any*/),
  (v26/*: any*/)
],
v28 = {
  "concreteType": "CcpEntitlementExperienceCapabilities",
  "kind": "LinkedField",
  "name": "experienceCapabilities",
  "plural": false,
  "selections": [
    {
      "args": [
        (v24/*: any*/)
      ],
      "concreteType": "CcpChangeOfferingExperienceCapability",
      "kind": "LinkedField",
      "name": "changeOfferingV2",
      "plural": false,
      "selections": (v27/*: any*/),
      "storageKey": "changeOfferingV2(offeringName:\"Standard\")"
    },
    {
      "condition": "shouldCheckForDirectBuyChangeOffering",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "changeOfferingV2WithSkipTrial",
          "args": [
            (v24/*: any*/),
            {
              "kind": "Literal",
              "name": "skipTrial",
              "value": true
            }
          ],
          "concreteType": "CcpChangeOfferingExperienceCapability",
          "kind": "LinkedField",
          "name": "changeOfferingV2",
          "plural": false,
          "selections": (v27/*: any*/),
          "storageKey": "changeOfferingV2(offeringName:\"Standard\",skipTrial:true)"
        }
      ]
    }
  ]
},
v29 = {
  "condition": "shouldCheckForChargeQuantities",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "chargeElement",
          "variableName": "chargeElement"
        }
      ],
      "kind": "ScalarField",
      "name": "latestUsageForChargeElement"
    }
  ]
},
v30 = {
  "concreteType": "CcpEntitlementPreDunning",
  "kind": "LinkedField",
  "name": "preDunning",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "status"
    }
  ]
},
v31 = {
  "concreteType": "CcpTrial",
  "kind": "LinkedField",
  "name": "trial",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "timeLeft"
    },
    {
      "kind": "ScalarField",
      "name": "startTimestamp"
    },
    {
      "kind": "ScalarField",
      "name": "endTimestamp"
    }
  ]
},
v32 = {
  "kind": "ScalarField",
  "name": "invoiceable"
},
v33 = {
  "concreteType": "CcpInvoiceGroupExperienceCapabilities",
  "kind": "LinkedField",
  "name": "experienceCapabilities",
  "plural": false,
  "selections": [
    {
      "concreteType": "CcpConfigurePaymentMethodExperienceCapability",
      "kind": "LinkedField",
      "name": "configurePaymentV2",
      "plural": false,
      "selections": [
        (v26/*: any*/),
        (v25/*: any*/)
      ]
    }
  ]
},
v34 = {
  "concreteType": "CcpOfferingTrial",
  "kind": "LinkedField",
  "name": "trial",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "lengthDays"
    }
  ]
},
v35 = {
  "kind": "ScalarField",
  "name": "key"
},
v36 = {
  "kind": "ScalarField",
  "name": "isCurrentUserBillingAdmin"
},
v37 = {
  "condition": "shouldCheckForPaymentDetails",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "CcpTransactionAccount",
      "kind": "LinkedField",
      "name": "transactionAccount",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isBillToPresent"
        }
      ]
    }
  ]
},
v38 = {
  "condition": "shouldCheckForAddPaymentDetails",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "CcpTransactionAccount",
      "kind": "LinkedField",
      "name": "transactionAccount",
      "plural": false,
      "selections": [
        {
          "concreteType": "CcpTransactionAccountExperienceCapabilities",
          "kind": "LinkedField",
          "name": "experienceCapabilities",
          "plural": false,
          "selections": [
            {
              "concreteType": "CcpAddPaymentMethodExperienceCapability",
              "kind": "LinkedField",
              "name": "addPaymentMethodV2",
              "plural": false,
              "selections": (v27/*: any*/)
            }
          ]
        }
      ]
    }
  ]
},
v39 = {
  "kind": "ScalarField",
  "name": "relationshipType"
},
v40 = [
  (v39/*: any*/),
  (v22/*: any*/)
],
v41 = {
  "condition": "shouldUseFilteredEntitlementRelationships",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "concreteType": "CcpEntitlementRelationship",
      "kind": "LinkedField",
      "name": "relatesFromEntitlements",
      "plural": true,
      "selections": (v40/*: any*/)
    }
  ]
},
v42 = {
  "condition": "shouldUseFilteredEntitlementRelationships",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "relatesFromEntitlementsWithEnterpriseType",
      "args": [
        {
          "kind": "Literal",
          "name": "relationshipTypes",
          "value": "ENTERPRISE"
        }
      ],
      "concreteType": "CcpEntitlementRelationship",
      "kind": "LinkedField",
      "name": "relatesFromEntitlements",
      "plural": true,
      "selections": (v40/*: any*/),
      "storageKey": "relatesFromEntitlements(relationshipTypes:\"ENTERPRISE\")"
    }
  ]
},
v43 = [
  {
    "kind": "Literal",
    "name": "relationshipTypes",
    "value": "COLLECTION"
  }
],
v44 = {
  "concreteType": "GrowthUnifiedProfileEntitlementProfileResult",
  "kind": "LinkedField",
  "name": "entitlementProfile",
  "plural": false,
  "selections": [
    {
      "concreteType": "GrowthUnifiedProfileEntitlementContextTrialResult",
      "kind": "LinkedField",
      "name": "lastKnownTrial",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "trialType"
        },
        {
          "kind": "ScalarField",
          "name": "trialTrigger"
        },
        {
          "kind": "ScalarField",
          "name": "trialEndTimeStamp"
        },
        {
          "kind": "ScalarField",
          "name": "createdAt"
        },
        {
          "kind": "ScalarField",
          "name": "offeringId"
        }
      ]
    }
  ]
},
v45 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/)
    ],
    "kind": "Fragment",
    "name": "editionAwarenessQuery",
    "selections": [
      (v16/*: any*/),
      (v19/*: any*/),
      {
        "args": (v20/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v21/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v22/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": (v23/*: any*/),
                    "concreteType": "CcpEntitlement",
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      (v28/*: any*/),
                      (v29/*: any*/),
                      {
                        "condition": "shouldCheckForTrial",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v30/*: any*/),
                          {
                            "concreteType": "CcpSubscription",
                            "kind": "LinkedField",
                            "name": "subscription",
                            "plural": false,
                            "selections": [
                              (v31/*: any*/),
                              {
                                "concreteType": "CcpAccountDetails",
                                "kind": "LinkedField",
                                "name": "accountDetails",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "CcpInvoiceGroup",
                                    "kind": "LinkedField",
                                    "name": "invoiceGroup",
                                    "plural": false,
                                    "selections": [
                                      (v32/*: any*/),
                                      (v33/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "concreteType": "CcpOffering",
                            "kind": "LinkedField",
                            "name": "offering",
                            "plural": false,
                            "selections": [
                              (v34/*: any*/),
                              (v35/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "CcpTransactionAccount",
                        "kind": "LinkedField",
                        "name": "transactionAccount",
                        "plural": false,
                        "selections": [
                          (v35/*: any*/),
                          (v36/*: any*/)
                        ]
                      },
                      (v37/*: any*/),
                      (v38/*: any*/),
                      (v41/*: any*/),
                      (v42/*: any*/),
                      {
                        "alias": "relatesFromEntitlementsWithCollectionType",
                        "args": (v43/*: any*/),
                        "concreteType": "CcpEntitlementRelationship",
                        "kind": "LinkedField",
                        "name": "relatesFromEntitlements",
                        "plural": true,
                        "selections": [
                          (v39/*: any*/),
                          (v22/*: any*/),
                          {
                            "concreteType": "CcpEntitlement",
                            "kind": "LinkedField",
                            "name": "entitlement",
                            "plural": false,
                            "selections": [
                              (v30/*: any*/),
                              (v44/*: any*/)
                            ]
                          }
                        ],
                        "storageKey": "relatesFromEntitlements(relationshipTypes:\"COLLECTION\")"
                      },
                      (v44/*: any*/)
                    ]
                  }
                ],
                "type": "CommerceEntitlementInfoCcp"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v5/*: any*/),
      (v8/*: any*/),
      (v12/*: any*/),
      (v7/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v11/*: any*/),
      (v0/*: any*/),
      (v10/*: any*/),
      (v9/*: any*/),
      (v6/*: any*/),
      (v4/*: any*/),
      (v13/*: any*/)
    ],
    "kind": "Operation",
    "name": "editionAwarenessQuery",
    "selections": [
      {
        "args": (v20/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v21/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v22/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": (v23/*: any*/),
                    "concreteType": "CcpEntitlement",
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      (v28/*: any*/),
                      {
                        "concreteType": "CcpTransactionAccount",
                        "kind": "LinkedField",
                        "name": "transactionAccount",
                        "plural": false,
                        "selections": [
                          (v35/*: any*/),
                          (v36/*: any*/),
                          (v45/*: any*/)
                        ]
                      },
                      {
                        "alias": "relatesFromEntitlementsWithCollectionType",
                        "args": (v43/*: any*/),
                        "concreteType": "CcpEntitlementRelationship",
                        "kind": "LinkedField",
                        "name": "relatesFromEntitlements",
                        "plural": true,
                        "selections": [
                          (v39/*: any*/),
                          (v22/*: any*/),
                          {
                            "concreteType": "CcpEntitlement",
                            "kind": "LinkedField",
                            "name": "entitlement",
                            "plural": false,
                            "selections": [
                              (v30/*: any*/),
                              (v44/*: any*/),
                              (v45/*: any*/)
                            ]
                          }
                        ],
                        "storageKey": "relatesFromEntitlements(relationshipTypes:\"COLLECTION\")"
                      },
                      (v44/*: any*/),
                      (v45/*: any*/),
                      (v29/*: any*/),
                      {
                        "condition": "shouldCheckForTrial",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v30/*: any*/),
                          {
                            "concreteType": "CcpSubscription",
                            "kind": "LinkedField",
                            "name": "subscription",
                            "plural": false,
                            "selections": [
                              (v31/*: any*/),
                              {
                                "concreteType": "CcpAccountDetails",
                                "kind": "LinkedField",
                                "name": "accountDetails",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "CcpInvoiceGroup",
                                    "kind": "LinkedField",
                                    "name": "invoiceGroup",
                                    "plural": false,
                                    "selections": [
                                      (v32/*: any*/),
                                      (v33/*: any*/),
                                      (v45/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v45/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "CcpOffering",
                            "kind": "LinkedField",
                            "name": "offering",
                            "plural": false,
                            "selections": [
                              (v34/*: any*/),
                              (v35/*: any*/),
                              (v45/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v37/*: any*/),
                      (v38/*: any*/),
                      (v41/*: any*/),
                      (v42/*: any*/)
                    ]
                  }
                ],
                "type": "CommerceEntitlementInfoCcp"
              }
            ]
          }
        ]
      },
      (v16/*: any*/),
      (v19/*: any*/)
    ]
  },
  "params": {
    "id": "70fcb97b8d5b72ad8c5f32ae12ecd53cb532ddd2c3aa3a519541d82f83df46f5",
    "metadata": {},
    "name": "editionAwarenessQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "daf0370fff94a4e3a529617e073c28db";

export default node;
